import { render } from "./InProcess.vue?vue&type=template&id=b6a69d88"
import script from "./InProcess.vue?vue&type=script&lang=js"
export * from "./InProcess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__